/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_Hint_CloseInputs */

const en_image_inspector_hint_close = /** @type {(inputs: Image_Inspector_Hint_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`close`)
};

const ar_image_inspector_hint_close = /** @type {(inputs: Image_Inspector_Hint_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إغلاق`)
};

const bn_image_inspector_hint_close = /** @type {(inputs: Image_Inspector_Hint_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বন্ধ`)
};

const de_image_inspector_hint_close = /** @type {(inputs: Image_Inspector_Hint_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const es_image_inspector_hint_close = /** @type {(inputs: Image_Inspector_Hint_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cerrar`)
};

const fr_image_inspector_hint_close = /** @type {(inputs: Image_Inspector_Hint_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fermer`)
};

const pt_image_inspector_hint_close = /** @type {(inputs: Image_Inspector_Hint_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fechar`)
};

const zh_image_inspector_hint_close = /** @type {(inputs: Image_Inspector_Hint_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭`)
};

const tr_image_inspector_hint_close = /** @type {(inputs: Image_Inspector_Hint_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kapat`)
};

const ru_image_inspector_hint_close = /** @type {(inputs: Image_Inspector_Hint_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`закрыть`)
};

const pl_image_inspector_hint_close = /** @type {(inputs: Image_Inspector_Hint_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zamknij`)
};

/**
* | output |
* | --- |
* | "close" |
*
* @param {Image_Inspector_Hint_CloseInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_hint_close = /** @type {((inputs?: Image_Inspector_Hint_CloseInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_Hint_CloseInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_hint_close(inputs)
	if (locale === "bn") return bn_image_inspector_hint_close(inputs)
	if (locale === "de") return de_image_inspector_hint_close(inputs)
	if (locale === "es") return es_image_inspector_hint_close(inputs)
	if (locale === "fr") return fr_image_inspector_hint_close(inputs)
	if (locale === "pt") return pt_image_inspector_hint_close(inputs)
	if (locale === "zh") return zh_image_inspector_hint_close(inputs)
	if (locale === "tr") return tr_image_inspector_hint_close(inputs)
	if (locale === "ru") return ru_image_inspector_hint_close(inputs)
	if (locale === "pl") return pl_image_inspector_hint_close(inputs)
	return en_image_inspector_hint_close(inputs)
});